import { Button, ButtonGroup, Form, Row, Col } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

const QASection = ({ data, qaAnswers, setFormData, errors }) => {
  const handleChange = (questionId, value) => {
    setFormData((prev) => ({
      ...prev,
      qaAnswers: {
        ...prev.qaAnswers,
        [questionId]: {
          ...prev.qaAnswers?.[questionId],
          value,
        },
      },
    }));
  };

  return (
    <Row>
      <Col lg={8} xl={9} className="qa-section">
        {data
          .sort((a, b) => a.admg_order - b.admg_order)
          .map((group) => (
            <div key={group.admg_id} className="mb-5">
              <h5 className="mb-3">{group.admg_title}</h5>

              {group?.admission_questions?.map((question) => (
                <div key={question.adm_quest_id} className="mb-4">
                  {question.adm_tf === 1 ? (
                    <>
                      <Row className="mb-2 flex-nowrap">
                        <Col xs={"auto"}>
                          <ButtonGroup className="me-3 ms-0">
                            <Button
                              size="sm"
                              name={`q_${question.adm_quest_id}`}
                              onClick={() =>
                                handleChange(question.adm_quest_id, 1)
                              }
                              value={1}
                              variant={
                                qaAnswers[question.adm_quest_id]?.value == 1
                                  ? "secondary"
                                  : "light"
                              }
                            >
                              <FormattedMessage id="yes" />
                            </Button>

                            <Button
                              size="sm"
                              name={`q_${question.adm_quest_id}`}
                              onClick={() =>
                                handleChange(question.adm_quest_id, 0)
                              }
                              value={0}
                              variant={
                                qaAnswers[question.adm_quest_id]?.value == 0
                                  ? "secondary"
                                  : "light"
                              }
                            >
                              <FormattedMessage id="no" />
                            </Button>
                          </ButtonGroup>

                          {/* <Form.Check
                            type="checkbox"
                            name={`q_${question.adm_quest_id}`}
                            id={`q_${question.adm_quest_id}`}
                            onChange={() =>
                              handleChange(
                                question.adm_quest_id,
                                qaAnswers[question.adm_quest_id]?.value == 1
                                  ? 0
                                  : 1 // toggle value
                              )
                            }
                            checked={
                              qaAnswers[question.adm_quest_id]?.value == 1
                            }
                          /> */}
                        </Col>
                        <Col xs={"auto"}>
                          <Form.Label>
                            {question.adm_desc}{" "}
                            {question.adm_mandatory === 1 && (
                              <span className="text-danger">*</span>
                            )}
                          </Form.Label>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    <>
                      <Form.Label>
                        {question.adm_desc}{" "}
                        {question.adm_mandatory === 1 && (
                          <span className="text-danger">*</span>
                        )}
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={2}
                        className="mt-2"
                        placeholder="Enter your answer"
                        value={qaAnswers[question.adm_quest_id]?.value || ""}
                      onChange={(e) =>
                        handleChange(question.adm_quest_id, e.target.value)
                      }
                      />
                    </>
                  )}
                  {/* Optional comment box for CheckBox */}
                  {/* {question.adm_tf === 1 ? (
                    <>
                      <Form.Control
                        as="textarea"
                        rows={2}
                        className="mt-2"
                        placeholder="Add comment (optional)"
                        value={qaAnswers[question.adm_quest_id]?.comment || ""}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            qaAnswers: {
                              ...prev.qaAnswers,
                              [question.adm_quest_id]: {
                                ...prev.qaAnswers?.[question.adm_quest_id],
                                comment: e.target.value,
                              },
                            },
                          }))
                        }
                      />
                    </>
                  ) : (
                    question.adm_quest_comment == 1 && (
                      <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="Enter your answer"
                        value={qaAnswers[question.adm_quest_id]?.value || ""}
                        onChange={(e) =>
                          handleChange(question.adm_quest_id, e.target.value)
                        }
                      />
                    )
                  )} */}

                  {errors[`qa_${question.adm_quest_id}`] && (
                    <Form.Text className="text-danger">
                      This question is required.
                    </Form.Text>
                  )}
                </div>
              ))}
            </div>
          ))}
      </Col>
    </Row>
  );
};

export default QASection;
